<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <img :src="importedImg1" :alt="altText" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <div class="textBox" style="white-space: pre-wrap">
          
          {{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import importedImg1 from "@/page/starlightinfomation/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      importedImg1: importedImg1,
      text: `Valoramos su privacidad. Esta Política de Privacidad describe cómo recopilamos, usamos, compartimos y protegemos su información personal cuando utiliza nuestra aplicación y nuestros servicios de préstamo en Chile.
1. Ámbito de aplicación
Esta política se aplica a toda la información personal recopilada a través de:
Nuestra aplicación móvil
Nuestro sitio web oficial
Comunicaciones por correo electrónico, teléfono o redes sociales
Formularios digitales de solicitud de crédito
2. Información que recopilamos
a. Datos personales identificables:
Nombre completo
RUN/RUT (Rol Único Tributario)
Fecha de nacimiento
Dirección postal y electrónica
Número de teléfono
b. Información financiera:
Ingresos mensuales
Ocupación y tipo de contrato laboral
Historial de crédito 
Datos bancarios (cuenta para depósito del préstamo)
c. Datos del dispositivo:
Tipo y modelo de dispositivo
Sistema operativo y versión
Dirección IP
Ubicación aproximada (geolocalización)
ID de publicidad del dispositivo (si corresponde)
d. Datos sensibles (si aplica y con consentimiento expreso):
Biometría facial para verificación de identidad
Imagen de cédula de identidad chilena (por ambas caras)
3. Finalidad del uso de los datos
La información recopilada se utiliza con los siguientes fines:
Evaluación crediticia: determinar su elegibilidad para acceder a un préstamo.
Prevención de fraude: detectar y prevenir actividades ilegales.
Cumplimiento normativo: cumplir con las obligaciones ante la CMF (Comisión para el Mercado Financiero) y la Ley N° 19.628.
Comunicación con el usuario: enviar notificaciones sobre su solicitud, vencimientos, promociones, o actualizaciones de servicio.
Mejora del servicio: realizar análisis estadísticos y operacionales para optimizar nuestros procesos.
Publicidad personalizada (si se autoriza): ofrecer productos o servicios financieros adaptados a su perfil.
4. Conservación de datos
Sus datos serán conservados durante el tiempo necesario para cumplir con las finalidades antes descritas, o durante los plazos exigidos por la legislación chilena. Una vez cumplidas dichas finalidades, sus datos podrán ser anonimizados o eliminados de forma segura.
5. Compartición de la información
Podemos compartir su información con:
Burós de crédito: como Equifax/DICOM para verificar su historial crediticio.
Proveedores de servicios: terceros que procesan datos en nuestro nombre, como servicios de verificación de identidad, almacenamiento en la nube, o mensajería.
Autoridades chilenas: si existe obligación legal o requerimiento judicial.
Empresas afiliadas: solo si son parte del mismo grupo empresarial y con finalidades compatibles.
No vendemos ni alquilamos información personal a terceros.
6. Seguridad de la información
Adoptamos medidas técnicas y administrativas razonables para proteger sus datos:
Cifrado SSL en la transmisión de datos
Servidores seguros y encriptados
Control de acceso interno
Auditorías regulares
No obstante, la transmisión de datos por Internet nunca es 100% segura. Usted comprende y acepta este riesgo.
7. Derechos del usuario
Usted podrá ejercer los derechos conferidos por la Ley N° 19.628:
Derecho de acceso
Derecho de rectificación
Derecho de cancelación o eliminación
Derecho de oposición al tratamiento
Derecho a revocar el consentimiento en cualquier momento
Para ejercer estos derechos, puede enviar una solicitud a:
Email: office@starlightinfomation.com
8. Cookies y tecnologías similares
Nuestro sitio web y aplicación pueden usar cookies o herramientas similares para:
Recordar sus preferencias
Medir el rendimiento de la plataforma
Personalizar la experiencia de usuario
Usted podrá gestionar el uso de cookies desde la configuración de su navegador.
9. Privacidad de menores
Nuestros servicios están dirigidos exclusivamente a personas mayores de 18 años. No recopilamos intencionalmente información de menores de edad. Si descubrimos que un menor ha proporcionado datos personales, los eliminaremos inmediatamente.
10. Modificaciones a la política
Nos reservamos el derecho a actualizar esta Política de Privacidad. Cualquier modificación se notificará a través de la aplicación o nuestro sitio web. Se considerará que usted acepta las modificaciones si continúa usando nuestros servicios.
Gracias por confiar en nuestros servicios. `,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  background-color: #ffffff;
  margin: 0px auto 0px;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.imgBox2 {
  transform: scale(95%);
}
.textBox {
  margin-left: 50px;
  margin-right: 50px;
  font-size: 18px;
  line-height: 2;
  color: #333333;
}

</style>
